import { Box } from "@mantine/core";
import PricingCardsSection from "./components/PricingCardsSection";
import PricingFAQSection from "./components/PricingFAQSection";
import PricingHeroSection from "./components/PricingHeroSection";
import HowItWorksSection from "./components/HowItWorksSection";
import IncludedFeaturesSection from "./components/IncludedFeaturesSection";
import CTASection from "@/components/shared/CTASection";

export default function PricingPage() {
  return (
    <Box>
      <PricingHeroSection />
      <HowItWorksSection />
      <PricingCardsSection />
      <IncludedFeaturesSection />
      <PricingFAQSection />
      <CTASection
        title="Ready to Get Started?"
        subtitle="Create your free account and start exploring verified companies today"
        buttons={[{ text: "Sign Up Free", link: "/signup", style: "primary", showIcon: true }]}
      />
    </Box>
  );
}
